import { useContext, useMemo } from "react";
import { DropdownOption, NamedProperty } from "sprint-common-web";

import { SingleMovieContext } from "../context/SingleMovieContext";
import { useMovieAssetsListUrlFilters } from "./useMovieAssetsListUrlFilters";
import { useSingleMovieDetails } from "./useSingleMovieDetails";

export interface VersionDetails {
    versionTypes: NamedProperty[];
    distributors: NamedProperty[];
    airlines: NamedProperty[];
}

export const useMovieAssetsListFilters = () => {
    const { movie } = useContext(SingleMovieContext);

    const {
        filters,
        trailersOptions,
        setStatusIds,
        setPage,
        setPageSize,
        setSort,
        clearFilters,
        setDistributorIds,
        setVersionTypeIds,
        setAssetTypes,
        setAssetOrigins,
        setAssetRecordTypes,
        setTrailers,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    } = useMovieAssetsListUrlFilters();

    const { getVersionDetails } = useSingleMovieDetails();

    const versionDetails = useMemo<VersionDetails>(() => getVersionDetails(movie), [movie]);

    const setStatuses = (statusIds: number[]): void => {
        setStatusIds(statusIds);
    };

    const setVersionTypes = (options?: DropdownOption[]): void => {
        const versionTypeIds = options?.map((option: DropdownOption) => option.key.toString());

        setVersionTypeIds(versionTypeIds);
    };

    const setDistributors = (options?: DropdownOption[]): void => {
        const distributorIds = options?.map((option: DropdownOption) => option.key.toString());

        setDistributorIds(distributorIds);
    };

    return {
        filters,
        versionDetails,
        trailersOptions,
        setTrailers,
        setStatuses,
        setSort,
        setPage,
        setPageSize,
        clearFilters,
        setDistributors,
        setVersionTypes,
        setAssetTypes,
        setAssetOrigins,
        setAssetRecordTypes,
        setCreatedDateFrom,
        setCreatedDateTo,
        setUpdatedDateFrom,
        setUpdatedDateTo
    };
};
